<template>
    <div class="form-field" :rel="name" v-bind:class="{'has-suffix': suffix, 'form-required': requiredForm, 'form-readonly': readOnly, 'has-lang': lang}">
        <div class="form-label" v-show="label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper" style="padding: 10px;">

                <div v-for="media in internalValue" v-if="internalValue">
                    <a :href="media.url" target="_blank">
                        <i class="icon icon-picture"></i>
                        <span>{{ media.original_filename }}</span>
                    </a>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormField',
        props: ['value','label','name','placeholder','suffix','lang','required','readonly','maxlength'],
        data: function () {
            return {
                internalValue: '',
                langClass:""
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.langClass = this.lang?"flag lang-"+this.lang:"";
            this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
            this.readOnly = this.readonly && (this.readonly == 'true' || this.readonly == true) ? true : false
        },
        methods: {
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Medias.vue